// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2q7lQ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__11YbA","obliqueLine":"membershipbadge_obliqueLine__2DgLO"};